import { Avatar, Grid, Typography, useTheme } from '@mui/material';
import { OperationIncidentNote } from 'src/networkRequest/operationsService';
import { formatDateV2 } from '../../../../utils/formatDate';
import { ActivityMenu } from '@pages/Operations/components';
import Utils from '../../../../utils/utils';
import { Dispatch, SetStateAction } from 'react';

type IncidentNoteProps = {
  note: OperationIncidentNote
  onEdit: () => void;
  onDelete: () => void;
  setSelectedItem: Dispatch<SetStateAction<any | null>>;
};

const IncidentNote: React.FC<IncidentNoteProps> = ({
  note,
  onEdit,
  onDelete,
  setSelectedItem
}) => {
  const theme = useTheme();
  const authorName = Utils.fullName(
    note.author.agency_official.first_name,
    note.author.agency_official.last_name
  );
  return (
    <Grid
      sx={{
        backgroundColor: theme.palette.grey[50],
        padding: '16px',
        marginBottom: '16px',
        borderRadius: '10px'
      }}
    >
      <Grid container sx={{
        justifyContent: 'space-between'
      }}>
        <Grid container>
          <Avatar
            sx={{ width: '24px', height: '24px', marginRight: '8px' }}
            alt={authorName}
            src={note.author.agency_official.img_url || undefined}
          />
          <Grid container sx={{ flexDirection: 'column' }}>
            <Typography>{authorName}</Typography>
            <Typography sx={{ color: theme.palette.text.secondary }}>
              {formatDateV2(note.performed_at)}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            alignItems: 'center',
            gap: 1
          }}>
          <ActivityMenu
            item={note}
            onEdit={onEdit}
            onDelete={onDelete}
            setSelectedItem={setSelectedItem}
          />
        </Grid>
      </Grid>
      <Typography
        sx={{
          mt: '16px',
          whiteSpace: 'pre-line'
        }}>{note.description}</Typography>
    </Grid>
  );
};

export default IncidentNote;
